import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { styleTypes } from "@/data/mockData";

interface StyleSelectorProps {
  selectedStyle: string;
  onSelectStyle: (styleId: string) => void;
}

export const StyleSelector = ({
  selectedStyle,
  onSelectStyle,
}: StyleSelectorProps) => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="text-xl">Vyberte designový styl</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {styleTypes.map((style) => (
            <div
              key={style.id}
              className={`cursor-pointer rounded-lg p-4 ${
                selectedStyle === style.id
                  ? "bg-[#14A48D]\/10 border-2 border-[#14A48D]"
                  : "border hover:border-[#14A48D]/50"
              }`}
              onClick={() => onSelectStyle(style.id)}
            >
              <div className="aspect-square rounded-md mb-2 overflow-hidden bg-gray-100 flex items-center justify-center">
                <img
                  src={style.image}
                  alt={style.name}
                  className="h-full w-full object-cover"
                />
              </div>
              <p className="text-center font-medium text-sm mt-2">
                {style.name}
              </p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
